<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    class="heroicon-shop heroicon heroicons-lg"
  >
    <path
      class="heroicon-shop-wall heroicon-component-fill"
      fill="#FFFFFF"
      d="M11 7h76v93H11V7zm9 67v18h18V74H20zm40 0v18h18V74H60zm8-55v17h6V19h-6zm-22 0v17h6V19h-6zm-22 0v17h6V19h-6zm20 55v20h10V74H44z"
    ></path>
    <path
      class="heroicon-shop-windows heroicon-component-fill"
      fill="#FFFFFF"
      d="M44 74h10v20H44V74zm-24 0h18v18H20V74zm40 0h18v18H60V74zm8-55h6v17h-6V19zm-22 0h6v17h-6V19zm-22 0h6v17h-6V19z"
    ></path>
    <rect
      class="heroicon-shop-cover-fill heroicon-component-fill"
      width="76"
      height="18"
      x="11"
      y="49"
      fill="#FFFFFF"
    ></rect>
    <polygon
      class="heroicon-shop-cover-stripes heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      points="12 50 11 50 11 66 17 66 17 52 21 52 21 66 27 66 27 52 31 52 31 66 37 66 37 52 41 52 41 66 47 66 47 52 51 52 51 66 57 66 57 52 61 52 61 66 67 66 67 52 71 52 71 66 77 66 77 52 81 52 81 66 87 66 87 50 86 50 86 49 12 49"
    ></polygon>
    <path
      class="heroicon-shop-frames heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M33 36h2v4H19v-4h2V16h12v20zm22 0h2v4H41v-4h2V16h12v20zm22 0h2v4H63v-4h2V16h12v20zM24 19v17h6V19h-6zm22 0v17h6V19h-6zm22 0v17h6V19h-6zM17 71h24v24H17V71zm3 3v18h18V74H20zm37-3h24v24H57V71zm3 3v18h18V74H60z"
    ></path>
    <path
      class="heroicon-shop-door heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M41 71h16v29H41V71zm3 3v20h10V74H44z"
    ></path>
    <rect
      class="heroicon-shop-roof heroicon-component-accent heroicon-component-fill"
      width="82"
      height="8"
      x="8"
      fill="#7ACFC0"
    ></rect>
    <path
      class="heroicon-shadows"
      fill="#000000"
      d="M12 67h74v6H12v-6zm0-59h74v2H12V8zm7 32h16v2H19v-2zm22 0h16v2H41v-2zm22 0h16v2H63v-2z"
      opacity=".2"
    ></path>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M10 0h80v8h-2v90h12v2H0v-2h10V8H8V0h2zm76 8H12v40h74V8zM40 72H18v22h22V72zm40 22V72H58v22h22zM65 36V16h12v20h2v4H63v-4h2zm4-9h5v-8h-6v8h1zm5 1h-6v8h6v-8zm-7 8V18h8v18h1V17H66v19h1zm-3 1v2h14v-2H64zM21 17v-1h12v20h2v4H19v-4h2V17zm3 10h6v-8h-6v8zm0 1v8h6v-8h-6zm-1-9v-1h8v18h1V17H22v19h1V19zm11 18H20v2h14v-2zm8-1h1V16h12v20h2v4H41v-4h1zm4-9h6v-8h-6v8zm6 9v-8h-6v8h6zm-7-17v-1h8v18h1V17H44v19h1V19zm11 18H42v2h14v-2zM19 73h20v20H19V73zm19 1H20v18h18V74zm21-1h20v20H59V73zm1 1v18h18V74H60zM88 2H10v2h78V2zM10 6h78V5H10v1zm76 92V67h-5v31h5zm-6 0v-3H58v3h22zm-24 0V88h-1v7H43V73h12v9h1V72H42v26h14zm-16 0v-3H18v3h22zm-23 0V67h-5v31h5zm-5-48v1h74v-1H12zm70 2v8h4v-8h-4zm0 9v4h4v-4h-4zm-1 4v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm24 7H18v4h22v-4zm2 4h14v-4H42v4zm38-4H58v4h22v-4zM54 83v4h2v-4h-2zm0 5h-1v-2h-9v8h10v-6zm-10-3h9v-3h1v-8H44v11z"
    ></path>
  </svg>
</template>
